export default {
  ANONYMOUS_ID: 'anonymousId',
  PORTAL_TASK: 'portalTask',
  SUGGESTED_VALUES: 'suggestedValues',
  USER_ID: 'userId',
  WHAMMY_ID: 'whammyId',
  CUSTOMER_ID: 'customer_id',
  REQUESTOR_ID: 'requestor_id'
};
